export default __webpack_public_path__ + "static/media/ic_camera.ce970116.svg";